/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionproblemendpassed3Inputs */

const en_actionproblemendpassed3 = /** @type {(inputs: Actionproblemendpassed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This time has already passed.`)
};

const de_actionproblemendpassed3 = /** @type {(inputs: Actionproblemendpassed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Uhrzeit ist schon vorbei.`)
};

/**
* | output |
* | --- |
* | "This time has already passed." |
*
* @param {Actionproblemendpassed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionproblemendpassed3 = /** @type {((inputs?: Actionproblemendpassed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionproblemendpassed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionproblemendpassed3(inputs)
	return de_actionproblemendpassed3(inputs)
});
export { actionproblemendpassed3 as "actionProblemEndPassed" }